/*  Config */
import config from '../../../config/config';

export const Config = {
  // API接口地址
  api_url: config.reqDomains(),
};




// WEBPACK FOOTER //
// ./src/components/common/api.js